import BulkOrderItemsIndexPage from '../../../components/pages/bulk_order/items/BulkOrderItemsIndexPage.vue'
export default {
  components: {
    BulkOrderItemsIndexPage
  }
}
